/* eslint-disable @typescript-eslint/no-explicit-any */
import type { SelectProps } from '@radix-ui/react-select'
import type { Control } from 'react-hook-form'

import { FormControl, FormField, FormItem, FormLabel } from './ui/form'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from './ui/select'

type Options = {
	value: string
	label: string
}

type Props<T> = SelectProps & {
	label: string
	control: Control<any>
	name: Extract<keyof T, string>
	options?: Options[]
	onChange?: (value: string) => void
	disabled?: boolean
}

export function SelectFormComponent<T>({
	control,
	name,
	disabled,
	label,
	options,
	onChange,
	...rest
}: Props<T>) {
	const { required } = rest
	return (
		<FormField
			control={control}
			name={name}
			render={({ field }) => (
				<FormItem className="flex flex-col flex-1">
					<FormLabel className="flex font-normal">
						{label} {required && <p className="text-red-500">*</p>}
					</FormLabel>
					<Select
						disabled={disabled}
						onValueChange={(value) => {
							field.onChange(value)
							onChange?.(value)
						}}
						value={field.value}
						defaultValue={field.value}
						{...rest}
					>
						<FormControl>
							<SelectTrigger value={field.value} defaultValue={field.value}>
								<SelectValue placeholder="Selecione uma opção" />
							</SelectTrigger>
						</FormControl>
						<SelectContent className='max-h-60'>
							{options?.map((param) => (
								<SelectItem
									className="text-wrap md:max-w-full text-md py-2"
									key={param.value}
									value={param.value.toString()}
								>
									{param.label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</FormItem>
			)}
		/>
	)
}
